module.exports = require("material-ui/styles");


//////////////////
// WEBPACK FOOTER
// external "material-ui/styles"
// module id = 25
// module chunks = 0